import { Box, Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import FilterSection from '../TopCardOverview/FilterSection';
import dayjs from 'dayjs';
import { typeOfStudent } from '../../../../utils/constants/GlobalStaticData';
import CardModule from '../TopCardOverview/CardModule';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getCroOgaUnderProjectInRefundRequests, secondCardCounts } from '../../../../redux/features/refundSlice';

const SecondCardSections = () => {
  const {
    secondCardCounts: { data, secondCardCountsLoading },
    croAndOgaRefundList: { cro: croList, oga: ogaList },
  } = useSelector((state) => state.refund);
  const [showFilters, setShowFilters] = useState(true);
  const [selectedType, setSelectedType] = useState(typeOfStudent[0]);
  const [projectId, setProjectId] = useState(null);
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD')); //DEFAULT SET TO CURRENT MONTH STARTING DATE TO ENDING DATE
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [selectedReason, setSelectedReason] = useState({ id: null, value: null });
  const [selectedCro, setSelectedCro] = useState({ id: null, value: null });
  const [selectedOga, setSelectedOga] = useState({ id: null, value: null });
  const dispatch = useDispatch();
  const cardData = [
    {
      title: 'Total Request',
      value: 'total_refund_request',
      type: 'number',
    },
    {
      title: 'Total Requested Amount',
      value: 'total_refund_request_amount',
      type: 'rupees',
    },
    {
      title: 'Total Approved Request',
      value: 'total_approved_by_finance',
      type: 'number',
    },
    {
      title: 'Total Approved Amount',
      value: 'total_approved_amount',
      type: 'rupees',
    },
    {
      title: 'Average Refund Amount',
      value: 'average_paid_refund_amount',
      type: 'rupees',
    },
    {
      title: 'Less Than 5 Sessions',
      value: 'less_than_5_sessions_count',
      type: 'number',
    },
    {
      title: 'Scheduled Payments',
      value: 'scheduled_payments_count',
      type: 'number',
    },
    {
      title: 'Scheduled Payments Amount',
      value: 'scheduled_payments_amount',
      type: 'number',
    },
    {
      title: 'Total Refunded Amount',
      value: 'total_refund_request_amount',
      type: 'rupees',
    },
  ];

  const dispatchParams = useMemo(() => {
    return {
      type: selectedType?.id,
      projectId: projectId || null,
      fromDate: fromDate,
      toDate: toDate,
      reason: selectedReason?.value,
      cro_id: selectedCro?.id,
      oga_id: selectedOga?.id,
    };
  }, [selectedType, projectId, fromDate, toDate, selectedCro, selectedOga, selectedReason]);

  useEffect(() => {
    dispatch(secondCardCounts(dispatchParams));
  }, []);

  useEffect(() => {
    if (projectId) {
      dispatch(getCroOgaUnderProjectInRefundRequests(projectId));
    }
  }, [projectId]);

  const filterSubmit = React.useCallback(() => {
    dispatch(secondCardCounts(dispatchParams));
  }, [dispatch, dispatchParams]);
  return (
    <Box>
      <Box>
        <FilterSection
          showFilters={showFilters}
          setShowFilters={setShowFilters}
          selectedType={selectedType}
          setSelectedType={setSelectedType}
          projectId={projectId}
          setProjectId={setProjectId}
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
          filterSubmit={filterSubmit}
          loading={secondCardCountsLoading}
          selectedReason={selectedReason}
          setSelectedReason={setSelectedReason}
          selectedCro={selectedCro}
          setSelectedCro={setSelectedCro}
          selectedOga={selectedOga}
          setSelectedOga={setSelectedOga}
          croList={croList}
          ogaList={ogaList}
        />
      </Box>
      <Grid container spacing={2} mt={1}>
        {cardData.map(({ title, type, value }, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <CardModule
              title={title}
              value={data?.[value] ?? 0}
              type={type}
              //  defalutColor={'linear-gradient(135deg, #243A5E 0%, #602323 100%)'}
              defalutColor={'linear-gradient(135deg, #4f94d7 0%, #002F6C 100%)'}
              loading={secondCardCountsLoading}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SecondCardSections;
